var parent = require('../../es/promise');
require('../../modules/web.dom-collections.iterator');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/stable/promise/index.js
// module id = 283
// module chunks = 0 1